import { Component, HostListener, Input } from '@angular/core';

@Component({
    selector: 'atx-go-top',
    template: `<div class="container text-right">
    <button class="btn btn-dark btn-sm"
            (click)="onScrollToTop()"
            *ngIf="hasButton">
    </button>
</div>
`,
    styles: [`button{height:27px;margin-bottom:.5em;border-radius:50%;text-align:center;line-height:5px;opacity:.3!important}button:hover{opacity:1!important}`],
})

export class AtxGoTopComponent {
    @Input() public readonly distance: number = 200;

    public hasButton: boolean;

    @HostListener('window:scroll', [])
    public windowScroll() {
        this.hasButton = window.pageYOffset > this.distance;
    }

    public onScrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
}
